define('responsive-pitch-fx/lib/workers/PitchRaster',['require','exports','module','../math/precision'],function(require,exports,module){
    var sqrt    = Math.sqrt,
        min     = Math.min,
        power   = Math.pow,
        abs     = Math.abs,
        precision = require( '../math/precision' );


    function positionAtTime(p) {
        var p0 = p + '0',
            vp0 = 'v' + p0,
            ap = 'a' + p;

        return function (t) {
            return !isNaN(this.coords[p0]) && (this.coords[p0] + (this.coords[vp0] * t) + ((0.5 * this.coords[ap]) * (t * t))) || this.coords[p];
        }
    }

    function PitchRaster(pitch,renderer){
        this.pitch=pitch;
        this.coords = pitch.coords;
        this.renderer=renderer;
    }

    PitchRaster.prototype = {
        curveAtTime : function(t, coord) {
            return this['v' + coord + '0'] + this['a' + coord] * t;
        },
        xPositionAtTime : positionAtTime('x'),
        // Use Z as Y when converting from pfx coords
        yPositionAtTime : positionAtTime('z'),
        // Use -Y as Z when converting from pfx coords
        zPositionAtTime : (function(t){
            var getZ=positionAtTime('y');

            return function(t){
                    // Negate Z
                return -1 * getZ.call(this,t);
            }
        })(),
        timeAtYPosition : function(yPosition) {
            var a = (-1.0 * this.coords.vy0),
                b = sqrt(this.coords.vy0 * this.coords.vy0 - 2 * this.coords.ay * (this.coords.y0 - yPosition));
            
            var time1 = (a + b) / this.coords.ay,
                time2 = (a - b) / this.coords.ay;

            return min(time1, time2);
        },

        pointOnGrid : function(x,y,z){
            var scalers=this.renderer.scalers,
                rayWidth;

            // Adjust y to be in the middle of the screen(camera is centered vertically)
            var newY = ((scalers.height - scalers.viewBottomMargin) / scalers.y * 0.5) - y,
            // Give the x,y perspective courtesy of z
                perspectiveX = x * (scalers.eyetoScreenX / abs(scalers.eyetoScreenX - z)),
                perspectiveY = newY * (scalers.eyetoScreenY / abs(scalers.eyetoScreenY - z)),

            // Put x,y into the view space taking into account its size
                screenX = perspectiveX * scalers.x + (scalers.width * scalers.x_center),
                screenY = perspectiveY * scalers.y + (scalers.height * 0.5) - scalers.viewBottomMargin;

            // Make sure its in the bounds
            screenX = screenX < 0.0 ? 0.0 : min(scalers.width, screenX);
            screenY = screenY < 0.0 ? 0.0 : min(scalers.height - scalers.viewBottomMargin, screenY);

            return [ precision(screenX), precision(screenY + scalers.YOffset), precision(z * scalers.x - scalers.viewBottomMargin),1];
        },
        points3D : function (time,step,numberOfPoints) {
            var x = this.xPositionAtTime(time),
                y = this.yPositionAtTime(time),
                z = this.zPositionAtTime(time)||0.1,
                scalers=this.renderer.scalers,
                point,
                rayWidth;
            // debugger;
            if (y < 0.1) {
                return null;
            }
            point=this.pointOnGrid(x,y,z);
            point[3]=min(power((scalers.fakeBallSize) / (this.pitch.startSpeed - this.pitch.endSpeed) / numberOfPoints * power(step, 2), 0.7), scalers.maxlinewidth * 1.8);

            return point;
        },

        points2D : function () {
            var x = this.coords.x,
                y = this.coords.y,
                rayWidth,
                scalers=this.renderer.scalers,
                screenX = (-x * 1.72 / scalers.base_width) * scalers.width + (scalers.width * 1.14) * scalers.x_center + scalers.offset_x,
                screenY = (y * 1.6 / scalers.base_height) * scalers.height + (scalers.height / 1.6 + scalers.viewBottomMargin) * scalers.y_center;

            // Make sure its in the bounds
            screenX = screenX < 0.0 ? 0.0 : min(scalers.width, screenX);
            screenY = screenY < 0.0 ? 0.0 : min(scalers.height, screenY);

            rayWidth=min(power((scalers.fakeBallSize) / (this.pitch.startSpeed - this.pitch.endSpeed) / 1 * power(1, 2), 0.7), scalers.maxlinewidth * 1.8);
            return [ screenX, screenY , null, rayWidth ] 
        }
    }

    return PitchRaster;    
});
